module.exports = "<button>Update Screen</button>\n"